import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { WishlistItem } from "../../interfaces/wishlistInterface";
import { fetchWishlist, addWishlistItem, removeWishlistItems } from "../../utils/api/apiGuest";

interface WishlistState {
  wishlistId: string | null;
  items: WishlistItem[];
  loading: boolean;
  error: string | null;
}

const initialState: WishlistState = {
  wishlistId: null,
  items: [],
  loading: false,
  error: null,
};

export const initializeWishlist = createAsyncThunk(
  "wishlist/initialize",
  async (wishlistIdFromStorage?: string) => {
    const res = await fetchWishlist(wishlistIdFromStorage);
    return { wishlistId: res.data?.wishlistId, items: res.data?.items };
  }
);

export const addToWishlist = createAsyncThunk(
  "wishlist/add",
  async ({ wishlistId, productId }: { wishlistId: string; productId: string }) => {
    await addWishlistItem(wishlistId, productId);
    return productId;
  }
);

export const removeFromWishlist = createAsyncThunk(
  "wishlist/remove",
  async ({ wishlistId, productId }: { wishlistId: string; productId: string }) => {
    await removeWishlistItems(wishlistId, [productId]);
    return productId;
  }
);

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    clearWishlist: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeWishlist.fulfilled, (state, action) => {
        state.wishlistId = action.payload.wishlistId;
        state.items = action.payload.items;
        localStorage.setItem("wishlistId", action.payload.wishlistId);
      })
      .addCase(addToWishlist.fulfilled, (state, action) => {
        if (!state.items.some(item => item.productId === action.payload)) {
          state.items.push({ productId: action.payload });
        }
      })
      .addCase(removeFromWishlist.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.productId !== action.payload);
      });
  },
});

export const { clearWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;